module.exports = __webpack_public_path__ + "media/images/area/shopping-297ec58056763aeec1b222b3365e5b35.jpg";